// extracted by mini-css-extract-plugin
export default {"checkbox":"FormCheckbox_checkbox__FUlPG","indicatorForChec":"FormCheckbox_indicatorForChec__-cX5g"};